/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteSetupParameterTemplateListValuesEntry } from '../../models/delete-setup-parameter-template-list-values-entry';

export interface DeleteSetupParameterTemplateListValues$Params {
      body: Array<DeleteSetupParameterTemplateListValuesEntry>
}

export function deleteSetupParameterTemplateListValues(http: HttpClient, rootUrl: string, params: DeleteSetupParameterTemplateListValues$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteSetupParameterTemplateListValues.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteSetupParameterTemplateListValues.PATH = '/api/v1/SetupParameter/DeleteSetupParameterTemplateListValuesList';
